import { FiSearch } from "react-icons/fi";

export default function QuickSearch({ onChange, onEnter }) {
  return (
    <div className="w-full">
      <label className="sr-only" htmlFor="qs">Rechercher dans le tutoriel</label>
      <div className="relative">
        <FiSearch className="absolute left-3 top-3.5 text-slate-400" />
        <input
          id="qs"
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onEnter?.();
          }}
          placeholder="Rechercher une étape, une page, une question…"
          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 pl-10 pr-4 py-2 outline-none focus:ring-2 focus:ring-fuchsia-500/40"
        />
      </div>
      <p className="text-xs text-slate-500 mt-1">
        Astuce : tapez « facture », « inscription », « mot de passe », etc. (Appuyez sur Entrée pour aller au résultat suivant)
      </p>
    </div>
  );
}
